const sendGiftToggle = document.getElementById("sendGiftToggle");
const giftForm = document.getElementById("giftForm");
const addToBagBtn = document.getElementById("color-addtocart");
const emailInput = document.getElementById("recipient-email");
const errorMsg = document.getElementById("giftError");

// Checkbox toggles form
sendGiftToggle.addEventListener("change", function () {
  giftForm.classList.toggle("hidden");
  errorMsg.style.display = "none";
  emailInput.classList.remove("error");
  // Change button type when gift checkbox is checked
  if (sendGiftToggle.checked) {
    addToBagBtn.setAttribute("type", "button");
  } else {
    addToBagBtn.setAttribute("type", "submit");
  }
});

// Button click: validate email if gift is checked
addToBagBtn.addEventListener("click", function (e) {
  if (sendGiftToggle.checked && emailInput.value.trim() === "") {
    e.preventDefault(); // Stop form submission / add to bag
    emailInput.classList.add("error"); // Highlight input
    errorMsg.style.display = "block"; // Show error message
  } else {
    emailInput.classList.remove("error");
    errorMsg.style.display = "none";
  }
});

// Remove error styling when user starts typing
emailInput.addEventListener("input", function () {
  if (emailInput.value.trim() !== "") {
    emailInput.classList.remove("error");
    errorMsg.style.display = "none";
    addToBagBtn.setAttribute("type", "submit");
  }
});


//change price on variant change
const currency = window.Shopify.currency.active;

document.querySelectorAll(".variant-radios input").forEach((radio) => {
  radio.addEventListener("change", function () {

    const price = this.dataset.price; // ← GET data-price

    document.querySelector(".product-price").textContent =
      price + " " + currency;
  });
});



//data picker
const dateInput = document.getElementById("recipient-send-on");
const today = new Date().toISOString().split("T")[0]; // YYYY-MM-DD
dateInput.setAttribute("min", today);

dateInput.addEventListener('change', function () {
  console.log('test');
  if (this.value !== "") {
    this.classList.add("hide-before");
  } else {
    this.classList.remove("hide-before");
  }
});

